import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Image from './image';
import * as classes from './classes.module.scss';

export default class CustomImage extends PureComponent {
  static propTypes = {
    dpi: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    widthIn: PropTypes.number.isRequired,
    heightIn: PropTypes.number.isRequired,
    src: PropTypes.string.isRequired,
    dragging: PropTypes.bool.isRequired,
    moveCustomImageTo: PropTypes.func.isRequired
  };

  componentDidUpdate(prevProps) {
    const { x, y, moveCustomImageTo } = this.props;
    if (prevProps.x !== x || prevProps.y !== y) {
      moveCustomImageTo({ x, y });
    }
  }

  render() {
    const {
      dpi, dragging, src, heightIn, widthIn
    } = this.props;
    return (
      <Image
        widthIn={ widthIn }
        heightIn={ heightIn }
        dpi={ dpi }
        src={ src }
        className={ classnames({ [classes.draggingSilhouette]: dragging }) }
      />
    );
  }
}
